import { addMonths } from 'date-fns'

export const getLastPaymentDate = (firstPaymentDate: Date, installmentCount: number): Date => {
  return addMonths(firstPaymentDate, installmentCount - 1)
}
